import { Form } from "antd";
import { usePermissions } from "hooks/usePermissions";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";

export default function MultiEmailInput(): React.ReactElement {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const { isDemoClient } = usePermissions();
  const emailCount = isDemoClient ? 1 : 10;
  const emails = Form.useWatch("receivers", form) || [];

  useEffect(() => {
    if (emails.length === 0) {
      form?.setFields([
        {
          name: "receivers",
          errors: [t("This field is required")],
        },
      ]);
    } else {
      form?.setFields([
        {
          name: "receivers",
          errors: [],
        },
      ]);
    }
  }, [emails]);

  return (
    <ReactMultiEmail
      emails={emails}
      onChange={(_emails: string[]) => {
        form?.setFields([
          {
            name: "receivers",
            value: _emails,
          },
        ]);
      }}
      enable={({ emailCnt }) => {
        return emailCnt < emailCount;
      }}
      getLabel={(email, index, removeEmail) => {
        return (
          <div data-tag key={index}>
            <div data-tag-item>{email}</div>
            <span data-tag-handle onClick={() => removeEmail(index)}>
              ×
            </span>
          </div>
        );
      }}
    />
  );
}
